import {SignalRService} from '../signal-r.service';
import {HubConnection} from '@microsoft/signalr';
import {CrudActivity} from '../../../../activity-log/data/crudActivity';
import {EntityType} from '../../../data/EntityType';
import {CrudEvents} from './crudEvents';
import {OperationTypeEnum} from '../../../../activity-log/data/operationTypeEnum';
import {ActivityDTO} from '../../../../activity-log/data/activityDTO';
import {EventEmitter} from '@angular/core';

export class SignalRCrudHandler {

  static instance: SignalRCrudHandler;
  connection: HubConnection;

  attachmentEvents: CrudEvents = new CrudEvents();
  communicationEvents: CrudEvents = new CrudEvents();
  categoryEvents: CrudEvents = new CrudEvents();
  customerEvents: CrudEvents = new CrudEvents();
  jobEvents: CrudEvents = new CrudEvents();
  pltEvents: CrudEvents = new CrudEvents();
  snippetEvents: CrudEvents = new CrudEvents();
  appointmentEvents: CrudEvents = new CrudEvents();
  docEvents: CrudEvents = new CrudEvents();
  onReceive: EventEmitter<ActivityDTO> = new EventEmitter<ActivityDTO>();

  constructor(public signalRService: SignalRService) {
    this.signalRService = signalRService;
    SignalRCrudHandler.instance = this;
  }

  async hook(connection: HubConnection) {
    this.connection = connection;
    this.connection.on('CrudActivity', this.onCrudActivity);
  }

  onCrudActivity(json: string) {
    const data: ActivityDTO = JSON.parse(json);
    SignalRCrudHandler.instance.onReceive.emit(data);
    const crudData = data.activityData as CrudActivity;
    const eventsRoot = SignalRCrudHandler.instance.selectEventsRoot(crudData);
    const operationEvent = SignalRCrudHandler.instance.selectOperationEvent(crudData, eventsRoot);
    operationEvent.emit(data.activityData as CrudActivity);
  }

  private selectEventsRoot(crudData: CrudActivity) {
    switch (crudData.entityType) {
      case EntityType.Attachment:
        return this.attachmentEvents;
      case EntityType.Communication:
        return this.communicationEvents;
      case EntityType.Category:
        return this.categoryEvents;
      case EntityType.Customer:
        return this.customerEvents;
      case EntityType.Job:
        return this.jobEvents;
      case EntityType.Task:
        return this.jobEvents;
      case EntityType.SubTask:
        return this.jobEvents;
      case EntityType.PaymentLinkTemplate:
        return this.attachmentEvents;
      case EntityType.Snippet:
        return this.snippetEvents;
      case EntityType.Appointment:
        return this.appointmentEvents;
      case EntityType.Document:
        return this.docEvents;
    }
  }

  private selectOperationEvent(crudData: CrudActivity, eventsRoot: CrudEvents) {
    switch (crudData.operation) {
      case OperationTypeEnum.Add:
        return eventsRoot.create;
      case OperationTypeEnum.Edit:
        return eventsRoot.update;
      case OperationTypeEnum.Delete:
        return eventsRoot.delete;
      case OperationTypeEnum.Reparent:
        return eventsRoot.update;
    }
  }
}

